import { useEffect } from 'react'
import { useAuthStore } from '@/store/auth-store'
import { useModal } from '@/components/Modal'
import { ModalTypes } from '@/components/Modal'
import { useDateStore } from '@/components/DateInput'
import { NIGHT_SHIFT_END_HOUR } from '@/modules/Auth/helpers/useNightShiftInfo'

export const useShowConfirmDetailsModal = () => {
    const { xUserShiftId } = useAuthStore()
    const { openModal } = useModal()
    const { setDate } = useDateStore()
    // const { isNightShift } = useNightShiftInfo()

    useEffect(() => {
        // open confirm details modal if user shift id is not set
        if (!xUserShiftId) {
            openModal(ModalTypes.confirmDetails)
        }

        const londonTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }))

        if (londonTime.getHours() < NIGHT_SHIFT_END_HOUR) {
            setDate(new Date(Date.now() - 24 * 60 * 60 * 1000)) // reset date to yesterday on night shift change
        } else {
            setDate(new Date()) // reset date to today on user shift change
        }
        // Don't depend on `openModal`, this will cause us to constantly re-run
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [xUserShiftId, setDate])
}
